import React from 'react';
import styled from 'styled-components';
import  ModalCore from './ModalCore.js';
import { connect } from "react-redux";
import {setValues , actCloseModal} from './redux';
import { Imglist } from './../../constants/ImagesList';

const ConfirmModal = (props) => {
	return (
		<ModalCore name="confirm" outSideClick={false}>
			<ConfirmModalContent className={"confirmmessage confirmmessage--" + props.modal_color}>
                <div className={"confirmmessage__head confirmmessage__head--" + props.modal_color}>
                    เลือกทีม
				</div>
                <div className="confirmmessage__content">
                    <div className="confirmmessage__text-head">
                        คุณต้องการที่จะเลือกทีม
                    </div>
                    <img src={Imglist['success_'+props.modal_color]} className="confirmmessage__icon" alt=''/>
                    <div className="confirmmessage__btn-group">
                        <img src={Imglist['btn_ok_'+props.modal_color]} onClick={()=>props.handleConfirm()} alt=''/>
                        <img src={Imglist['btn_cancel_'+props.modal_color]} onClick={()=>props.setValues({modal_open: ''})} alt=''/>
                    </div>
                </div>
			</ConfirmModalContent>
		</ModalCore>
	)
}

const mapStateToProps = state => ({
    ...state.Main,
    ...state.Modal
});

const mapDispatchToProps = { setValues ,actCloseModal};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmModal);

const ConfirmModalContent = styled.div`
    position: relative;
    z-index: 20;
    padding: 2%;
    pointer-events: visible;
    width: 90%;
    max-width: 700px;
    .confirmmessage{
        &__content{
            max-height: 80vh;
            overflow-y: scroll;
            width: 100%;
            margin: 0 auto;
            background: rgba(243,211,230,.8);
            border-bottom-right-radius: 25px;
            padding: 2%;
            text-align: center;
            @media(max-width: 1000px) {
                max-height: 50vh;
            }
        }
        &__text-head{
            color: #000;
            font-size: 2em;
            text-align: center;
        }
        &__icon{
            width: 50%;
        }
        &__head{
            text-align: center;
            font-size: 1.5em;
            color: #000;
            border-top-left-radius: 25px;
            &--red{
                background: #C59800;
            }
            &--yellow{
                background: #D20515;
            }
            &--blue{
                background: #CDFB0A;
            }
            &--green{
                background: #FF2983;
            }
        }
        &__btn-group{
            width: 100%;
            text-align: center;
            >img{
                display: inline-block;
                vertical-align: middle;
                width: 30%;
                margin: 0 2%;
                cursor: pointer;
                &:hover{
                    opacity: .8;
                }
            }
        }
    }
`;